import React from "react";
import logo from "../../../assets/images/inc-logo.png";
import "../../../assets/css/style.css";

const TermsUse = () => {
  return (
    <>
      <div className="headerpolicy">
        <div className="container">
          <img src={logo} alt="INC Logo" />
        </div>
      </div>

      <div className="main-wrapper">
        <div className="container">
          <h3 className="inc-heading">Terms of Use</h3>

          <p>
            These Terms of Service, including its appendixes specific to the
            country (“VVDN INC Service Agreement”, “VVDN INC Agreement”,
            “Agreement”) represent the terms and conditions applied to the
            access and use of the Intelligent Network Controller Platform,
            currently reachable at URL: “https://inc.vvdncloud.com/” by default
            or other configured custom domain that might be in use from time to
            time. This document is a legally binding agreement between the
            entity or person accepting these terms (“Customer” or “You”) that
            govern the application to services provided by VVDN Technologies
            Private Limited entity listed in Paragraph 2 below (referred to as
            “We”, “Our”, “VVDN” or “Intelligent Network Controller Platform”).
            By using the Intelligent Network Controller Platform, the Customer
            acknowledges and agrees that they have read, understood, and consent
            to be bound by the Terms, and all Your affiliate users or users
            approached by You (“End User”) to use Service are bound to this
            Terms of Service.
          </p>

          <h4 className="inc-blue-heading">
            1. Submission and Acceptance of the Terms
          </h4>
          <p style={{ paddingLeft: "2em" }}>
            1. Customer use of the Intelligent Network Controller Platform is
            subject to the terms and conditions contained in this document as
            well as the Intelligent Network Controller Platform Privacy Policy,
            and any other website or service policies or conditions as adopted
            and integrated with the Intelligent Network Controller Platform from
            time to time (jointly, the “Terms”).
          </p>

          <p style={{ paddingLeft: "2em" }}>
            2. This VVDN INC Service Agreement is effective (the "Effective
            Date") when a Customer accesses the Intelligent Network Controller
            Platform for the first time. If you are accepting Terms or accessing
            the platform on behalf of Customer, you represent and warrant that
            (i) you have full legal authority to bind Customer to this VVDN INC
            Service Agreement; (ii) you have read and understand this VVDN INC
            Service Agreement; and (iii) you agree, on behalf of Customer, to
            this VVDN INC Service Agreement. Vice versa, the Customer is deemed
            liable, represents and warrants that all users accept and comply
            with these Terms. Please do not use the Service if you do not agree
            to and accept all of the Terms. You acknowledge and agree that VVDN
            may amend any Terms at any time by posting the relevant amended and
            restated Terms on the Intelligent Network Controller Platform.
            Unless otherwise explicitly announced by VVDN, any changes to the
            Terms become effective right after they are posted. By continuing to
            use the Services, you agree to be bound by the latest released
            Terms.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            3. You may request to enter into other terms and conditions and
            agreements (“Additional agreement”), whether online or offline, with
            VVDN. If there is any conflict or inconsistency between the Terms
            and the said agreements, the Additional agreement shall take
            precedence over the Terms unless with respect to the services
            governed by the conflicting Additional Agreement.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            4. Assignment of the Terms to any person or entity is denied.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            5. VVDN may change the Terms from time to time where such change is
            required to comply with applicable law, applicable regulation, court
            order, or guidance issued by a governmental regulator or agency,
            where such change is expressly permitted by the data processing and
            security policies, or where such change:
          </p>
          <ul style={{ listStyleType: "lower-roman", marginLeft: "20px" }}>
            <li>is commercially reasonable;</li>
            <li>
              does not result in a degradation of the overall security of the
              Service;
            </li>
            <li>
              does not expand the scope of or remove any restrictions on the
              processing of Customer personal data, as described in the Privacy
              Policy;
            </li>
            <li>
              does not otherwise have a material adverse impact on Customer's
              rights.
            </li>
          </ul>

          <h4 className="inc-blue-heading">2. Provision of Service</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. The VVDN legal entity that you are contracting with is VVDN
            Technologies Private Limited. (referred as to "VVDN")
          </p>
          <p style={{ paddingLeft: "2em" }}>
            2. You must register as a customer on the Intelligent Network
            Controller Platform in order to access and use the Service.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            3. VVDN has the right to restrict, suspend or terminate your access
            to or use of the Intelligent Network Controller Platform or any
            features within the Service due to a breach of the Terms of Use or
            any Additional agreement.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            4. The features within the Service may vary for different regions
            and countries. VVDN gives no warranty or representation that the
            Service or feature or function thereof will be available in all
            countries and regions or for all users, especially for the Customers
            under the then-current sanctions list . VVDN Technologies. may in
            its sole discretion limit, deny or create different levels of access
            to and use of Service with respect to different users.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            5. VVDN may discontinue or modify the VVDN INC Service or certain
            functionality of the same at its sole discretion.
          </p>
          <h4 className="inc-blue-heading">
            3.Use of the Intelligent Cloud Engine Platform
          </h4>
          <p style={{ paddingLeft: "2em" }}>
            1. Your compliance with any and all applicable laws and regulations
            is a condition of your access to and use of the Service. You agree
            that you will not engage in fraudulent or deceptive practices and
            will not provide products and services to SDNs from the
            above-mentioned sanctions list, terrorists, extremists and all other
            illegal or semi-legal entities, when using the Service.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            2. With respect to content made available via the Service, the
            Customer and its End users agree that they will not: (a) copy,
            modify, or create a derivative work of the Service; (b) reverse
            engineer, decompile, translate, disassemble, or otherwise attempt to
            extract any or all of the source code of the Service (except to the
            extent such restriction is expressly prohibited by applicable
            law);(c) sell, resell, sublicense, transfer, or distribute any or
            all of the Service; (d) access or use the Service (i) for High Risk
            Activities, provisioned such use comes into effect, the Customer
            bears sole responsibility for any and all consequences; (ii)
            violating the Terms; (iii) intending to avoid incurring Fees or in a
            manner to omit Service-specific limits; (iv) to engage in
            cryptocurrency mining; (v) contravening the general purpose of the
            Service and its official documentation; (vi) for materials or
            activities that are subject to the International Traffic in Arms
            Regulations (ITAR) maintained by the United States Department of
            State; (vii) in a manner that breaches, or causes the breach of,
            Export Control Laws; or (viii) to transmit, store, or process
            personal information subject to GDPR and United States HIPAA
            regulations except as permitted by law;(e) without limiting the
            generality of the foregoing, copy, reproduce, download, compile or
            otherwise use the Service for the purposes of operating a business
            that competes with VVDN Cloud; (f) access or use the Service to
            produce, promote, provide to end users materials (i) that are
            defamatory, obscene, abusive, invasive of privacy, or offensive,
            including but not limited to content related to child pornography,
            bestiality, other types of illegal sexual content, and etc.; (ii)
            obtained from or via the Service for any purpose not expressly
            permitted in the Terms or the Additional Agreement; or (iii) that
            infringe or misappropriate the Intellectual Property Rights or
            proprietary rights of VVDN Technologies. or others in connection
            with your use of the Service.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            3. You agree that you will not: (a) undertake any action to gain
            unauthorized access to any computer, network, database, device of
            any Customer or End User; (b) intend to breach any security or
            authentication measures used in connection thereto; (c) forge your
            domicile and the origin of requests, including the faking of TCP/IP
            packet headers, email headers, or any part of any message describing
            its origin or route, operate any network services, such as open
            proxies, open mail relays, open recursive domain name servers, and
            etc.; (d) do any act which, in the sole opinion of VVDN
            Technologies. or by protection mechanisms of VVDN Intelligent
            Network Controller, may undermine the security of the Service and
            Customers; (e) engage in any denial of service (DoS) attacks,
            distributed denial of service (DDoS) attacks, or any other forms of
            network attacks potentially affecting the Service performance or
            availability to particular Customers.3.5 You agree that you will not
            distribute, send, or facilitate the sending or any unsolicited
            electronic commercial messages, or engage in any form of spamming
            activities that are in breach of the laws and regulations of any
            relevant jurisdiction or otherwise do any act or thing which
            constitutes promotion and marketing message abuse.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            4. You acknowledge and agree that by disclosing any information to
            us, you warrant that you have the full power, title and authority to
            disclose and submit such information and that the use of such
            information in accordance with these Terms of Use shall not expose
            us to any claim, liability, or prosecution.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            5. In addition to the Privacy Policy clauses in relation to personal
            data, you agree that any data and information, including personal
            data, provided to us for processing, storage, hosting or any other
            purposes in connection with your purchase and use of our Service
            (“Information”) will be transferred to, stored and processed in the
            country in which we maintain facilities for the Service. This may be
            in a different jurisdiction from where you are located, so such
            Information may need to be transferred to an overseas jurisdiction.
            3.8 You acknowledge and agree that any such overseas transfer or
            processing of such Information is necessary to process and
            administer your customer account and to provide the Service.{" "}
          </p>
          <p style={{ paddingLeft: "2em" }}>
            6. With respect to any other Information that you provide to us or
            collected by us, including Information provided at registration,
            Information we record pertaining to your activities, and Information
            provided voluntarily by you, we will not disclose such Information
            outside of us, our affiliates or our third party service providers
            unless: i) you request us to do so; ii) your end user has provided
            consent for us to do so; iii) as provided in these Terms of Use or
            in accordance with your agreement(s) with us, or iv) to comply with
            applicable law, legal process or lawful government requests, or in
            respect of any claims or potential claims brought against us.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            7. “VVDN” is a registered trademark. Customer is permitted to state
            publicly that it is a customer of the Service, consistent with the
            trademark guidelines. VVDN may include Customer's name in a list of
            VVDN customers, online or in promotional materials. VVDN may also
            verbally reference you as a customer of the Service.
          </p>
          <h4 className="inc-blue-heading">
            4. Withdrawal and suspension of the Service
          </h4>
          <p style={{ paddingLeft: "2em" }}>
            VVDN shall have the right at its sole and absolute discretion to
            remove, modify or reject any content that you submit to, post, or
            display on the Intelligent Network Controller Platform which in our
            sole opinion is unlawful, violates the Terms, or could subject VVDN
            Technologies. to liability without any refund claims.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            2. If we become aware that the Customer's or any Customer End User's
            use of the Service violates the Terms, we will give you notice of
            the violation requesting to cure the violation. If Customer fails to
            correct the violation within 24 hours of our request, then we may
            suspend all or part of Customer's use of the Service until the
            violation is corrected, or delete the customer account completely.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            3. Notwithstanding clause 4.1, VVDN may immediately suspend all or
            part of Customer's use of the Service if (i) we consider the breach
            of Paragraph 3 clauses; (ii) there is suspected unauthorized
            third-party access to the Service; (iii) it is necessary to withdraw
            immediately to comply with applicable law. At the Customer’s
            request, we will notify the Customer of the basis for the suspension
            as soon as reasonably possible. The lift of any such suspension is
            possible if the suspending event will have resolved within 15
            (fifteen) days after the suspension.
          </p>
          <h4 className="inc-blue-heading">5. Limitation of Liability</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. To the maximum extent permitted under applicable law, the Service
            is provided “as is”, “as available” and “with all faults”, and VVDN
            hereby expressly disclaims any and all warranties, express or
            implied, including but not limited to, any warranties of condition,
            quality, durability, performance, availability, accuracy,
            reliability, merchantability or fitness for a particular purpose,
            and non-infringement, or as to the Service being uninterrupted,
            error free, free of harmful components, secure, or not otherwise
            causing damage or loss of functionality or data.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            2. VVDN does not warrant the validity, accuracy, correctness,
            reliability,
          </p>
          <p style={{ paddingLeft: "2em" }}>
            3. Quality, stability, completeness or currency of any information
            provided on or through the Service.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            4. VVDN does not represent or warrant that use of products or
            services offered or displayed via the Service to End User does not
            violate any third party rights. Any material downloaded or otherwise
            obtained through the Services is done at your sole discretion and
            risk and you are solely responsible for any damage or loss of data
            that may result from the download of any such material.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            5. You hereby agree to indemnify and hold VVDN its respective
            affiliates, directors, officers and employees harmless from and
            against any and all losses, claims, liabilities which may arise from
            your use of the Service or from your breach of any of the Terms. You
            hereby further agree to indemnify and hold VVDN its affiliates,
            directors, officers and employees harmless, from and against any and
            all losses, damages, claims, and liabilities (including legal costs
            on a full indemnity basis) which may arise, directly or indirectly,
            as a result of any claims asserted by any third party claimants or
            other third parties relating to the use of Intelligent Cloud Engine
            Platform by you. You hereby further agree that VVDN is not
            responsible and shall have no liability to you, for any material
            posted or submitted by others, including defamatory, offensive or
            illicit material and that the risk of damages from such material
            rests entirely with you.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            6. VVDN shall not be liable for any special, direct, indirect,
            punitive, incidental or consequential damages or any damages
            whatsoever (including but not limited to damages for loss of profits
            or savings, business interruption, loss of information), whether in
            contract, negligence, tort, equity or otherwise or any other damages
            resulting from any of the following: (a) your use or inability to
            use the Service; (b) your violation of any third party rights, or
            claims against you by any party that they are entitled to defense or
            indemnification in relation to assertions of rights, demands or
            claims by any third party claimants; (c) unauthorized access by
            third parties to your data or private information; (d) your
            statements or conducts.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            7. Notwithstanding any of the foregoing provisions, unless otherwise
            provided in the Additional agreement, the aggregate liability of
            VVDN, and their respective employees, agents, affiliates,
            representatives, or anyone acting on their behalf with respect to
            you for any and all claims arising from or in connection with the
            Service or any use or inability to use the same during any calendar
            year shall be limited to USD 100 only. The preceding sentence shall
            not preclude the requirement by you to prove actual damages. All
            claims against VVDN in respect of any of the matters referenced in
            this clause 5.2 here above must be filed within 3 (three) months
            from the date the cause of action arose.
          </p>
          <h4 className="inc-blue-heading">6. Force Majeure</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. Under no circumstances shall VVDN be liable for any delay or
            failure or disruption of the content or the Service resulting
            directly or indirectly from acts of nature, forces or causes beyond
            our reasonable control, including without limitation, Internet
            failures, computer viruses, cyber-attacks, telecommunications or any
            other equipment failures, electrical power failures, strikes, labor
            disputes, riots, insurrections, quarantine lockdowns, civil
            disturbances, shortages of labor or materials, fires, flood, storms,
            explosions, acts of God, war, governmental actions, orders of
            domestic or foreign courts or tribunals or non-performance of third
            parties.
          </p>
          <h4 className="inc-blue-heading">
            7. Notice and Procedure for Making Claims of Copyright Infringement
          </h4>
          <p style={{ paddingLeft: "2em" }}>
            1. If you believe that your work has been copied in a way that
            constitutes copyright infringement, you may provide written notice
            to VVDN (in English only) to the address, as follows: Attn: Legal
            Counsel Email: legal@vvdntech.in VVDN Technologies Private Limited,
            Plot No: CP-07, IMT Manesar Rd, Sector 8, Imt Manesar, Gurugram,
            Haryana 122052
          </p>
          <h4 className="inc-blue-heading">8. Intellectual Property Rights</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. VVDN is the sole owner of all the rights and interests in the
            Intelligent Cloud Engine Platform. All title, ownership and
            Intellectual Property Rights in the Intelligent Network Controller
            Platform shall remain with VVDN, its affiliates.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            2. “Intellectual Property Rights” shall mean: (a) all rights, title
            and interest in and to all intellectual property rights, including
            any and all copyrights, patents, trademarks, service marks, logos,
            get-up, trade names, internet domain names, rights in designs,
            rights in computer software, database rights, semi-conductor
            topography rights, utility models and rights in know-how, in each
            case whether registrable or not, and including any applications for
            registration, and all rights or forms of protection having
            equivalent or similar effect anywhere in the world, and across all
            platforms and mediums whether now known or in the future
            invented;(b) all rights under licenses, consents, orders, statutes
            or otherwise in relation to any of the rights referenced above; (c)
            all rights of the same or similar effect or nature as or to those in
            sub-paragraphs (a) and (b) which now or in the future may subsist;
            (d) all rights to income, royalties, damages, claims and payments
            now or hereafter due or payable with respect thereto; and (e) all
            rights at law or in equity to sue for past or future infringements
            of any of the foregoing rights.
          </p>
          <h4 className="inc-blue-heading">9. Termination</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. This VVDN INC Agreement will begin on the date of first access to
            the Service and continue until the Agreement is terminated as stated
            in this Clause 9.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            2. The cancelation of the Service utilization by you causes the
            termination of this agreement for convenience. The Customer may stop
            using the Services at any time. VVDN may terminate this VVDN INC
            Agreement for its convenience at any time without any prior notice
            to the Customer.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            3. This Agreement stands automatically terminated if (i) the you are
            in material breach of the Agreement and fail to cure that breach
            within 30 (thirty) days after receipt of written notice or (ii) you
            cease its business operations or become subject to insolvency
            proceedings and the proceedings are not dismissed within 90 (ninety)
            days.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            4. Termination event means that all rights and access to the Service
            are terminated for Customer (including access to Customer Data, if
            applicable).
          </p>
          <h4 className="inc-blue-heading">10. General</h4>
          <p style={{ paddingLeft: "2em" }}>
            1. The Terms constitute the entire agreement between you and VVDN
            with respect to and govern the use of the Service, superseding any
            prior written or oral agreements in relation to the same subject
            matter herein.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            2. You and VVDN Technologies. are independent contractors, and no
            joint venture, partnership or other entity, employee-employer or
            franchisor-franchisee relationship is intended or created by this
            Agreement.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            3. If any term herein is adjudicated by a court or tribunal of
            competent jurisdiction to be void or unenforceable, the validity or
            enforceability of the remainder of the terms herein shall remain in
            full force and effect.
          </p>
          <p style={{ paddingLeft: "2em" }}>
            4. You shall not delegate, assign, sub-license or transfer any of
            the rights and/or obligations under this Agreement to any third
            party without our prior written consent.
          </p>
          <h4 className="inc-blue-heading">
            11. Governing Law and Dispute Resolution
          </h4>
          <p style={{ paddingLeft: "2em" }}>
            1. The Terms shall be governed by the laws of India without regard
            to its conflict of law provisions. The parties to the Terms hereby
            submit to the exclusive jurisdiction of the courts of New Delhi,
            India.
          </p>
        </div>
      </div>

      <footer>
        <div className="container">
          Powered by{" "}
          <a
            href="https://www.vvdntech.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            VVDN Technologies
          </a>
        </div>
      </footer>
    </>
  );
};

export default TermsUse;
